import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Droga} from "../../../domain/Droga";

@Injectable()
export class DrogaSQLService extends AbstractSQLService<Droga>{
    nomeTabela = "droga"
    agenciavel = false
}
